import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { 
  checkAuthAsync, 
  SelectIsAuthInitialized, 
  SelectIsLogged 
} from '../features/authentication/authenticationSlice';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isLogged = useAppSelector(SelectIsLogged);
  const isAuthInitialized = useAppSelector(SelectIsAuthInitialized);

  useEffect(() => {
    // Only verify cookie if we haven't verified it yet during this session
    if (!isAuthInitialized) {
      dispatch(checkAuthAsync());
    }
  }, [isAuthInitialized, dispatch]);

  // Still verifying cookie against the backend
  if (!isAuthInitialized) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <img src="/FadingCircles.gif" alt="בודק הרשאות..." />
      </div>
    );
  }

  // Finished check and user is not authenticated
  if (!isLogged) {
    return <Navigate to="/" replace />;
  }

  // Render children or nested route outlet
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;